module.exports = __webpack_public_path__ + "img/ring.9496b7e0.png";